import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "11",
  height: "11",
  viewBox: "0 0 11 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M1 10L4 5.5L1 1",
      stroke: "#AA1E2D",
      "stroke-width": "1.75",
      "stroke-miterlimit": "10"
    }, null, -1),
    _createElementVNode("path", {
      d: "M6 10L9 5.5L6 1",
      stroke: "#AA1E2D",
      "stroke-width": "1.75",
      "stroke-miterlimit": "10"
    }, null, -1)
  ]))]))
}
export default { render: render }